<template>
  <div id="cookie-banner"></div>
</template>

<script>
import { Trans } from "@/plugins/Translation";
import { mapActions } from "vuex";
export default {
  name: "cookieBanner",

  mounted() {
    // add mscc js script tag to document
    let msccScript = document.createElement("script");
    msccScript.type = "text/javascript";
    msccScript.src =
      "https://wcpstatic.microsoft.com/mscc/lib/v2/wcp-consent.js";
    document.body.appendChild(msccScript);

    // show banner when script is ready
    msccScript.onload = () => {
      // console.log("loaded");
      this.$nextTick(() => {
        // console.log("next tick", document.getElementById("cookie-banner"));

        window.WcpConsent.init(
          Trans.currentLanguage,
          "cookie-banner",
          (err, _siteConsent) => {
            // console.log("cookie init");
            if (!err) {
              const siteConsent = _siteConsent; //siteConsent is used to get the current consent
              this.cookiePolicy(siteConsent); // set to state
            } else {
              console.log("Error initializing WcpConsent: " + err);
            }
          },
          this.onConsentChanged,
          window.WcpConsent.themes.dark
        );
      });
    };
  },
  methods: {
    ...mapActions({
      cookiePolicy: "cookiePolicy"
    }),
    onConsentChanged(categoryPreferences) {}
  }
};
</script>

<style lang="scss">
#cookie-banner {
  // z-index: 100;
  position: fixed;
  bottom: 0;
  z-index: 100;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/CookieBanner.vue